<template>
  <b-row>
    <b-col
      v-for="group in items"
      :key="group.id"
      lg="3"
      md="4"
    >
      <group-card
        :group="group"
        @onEditButtonClicked="editButtonClicked"
        @onDeleteButtonClicked="deleteButtonClicked"
      />
    </b-col>
    <b-col cols="12">
      <groups-edit-modal
        :form="editForm"
        :additional-data="additionalData"
        @onItemCreated="createdItem"
        @onItemUpdated="updatedItem"
        @onHideModal="resetEditForm"
      />
    </b-col>
  </b-row>
</template>

<script>
import GroupCard from '../GroupCard'
import { ListTable } from '../../../common/mixins/list'
import GroupsEditModal from '../edit/GroupsEditModal'

export default {
  name: 'GroupsGrid',
  components: {
    GroupsEditModal,
    GroupCard,
  },
  mixins: [ListTable],
  data() {
    return {
      routeName: 'groups',
    }
  },
}
</script>

<style scoped>

</style>
